import { post } from './http'

export const submitFeedback = (messageId, type, comment) => {
    return post(`/tidb-ai/feedback`, {
        message_id: messageId,
        type: type,
        comment: comment
    })
}
